export enum Role {
  SUPER_ADMIN = 'super-admin',
  SUPER_ADMIN_ID = 'super_admin',
  USERS_ID = 'users',
  ADMIN_ID = 'admin'
}